import { useEffect, useState } from 'react';
import { AppWatch } from '@wajeez/wajeez.microservices';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import moment from 'moment';

const DailyUpgradeSubscriptionChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const { dailyUpgradeSubscription, dailyUpgradeSubscriptionStatus } =
    useAppwatchSelector((c) => c.paymentAnalysis);

  const [purchaseSource, setPurchaseSource] =
    useState<AppWatch.PurchaseSourceType>(
      AppWatch.PurchaseSourceType.CARD_DIRECT
    );

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyUpgradeSubscriptionAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        purchaseSourceType: purchaseSource,
      })
    );
  }, [dates, purchaseSource]);

  return (
    <div className="col-span-1">
      {' '}
      <Card>
        <div className="space-y-1">
          <ChartHeader
            title="Daily Upgrade Subscription"
            dates={dates}
            PurchaseSourceAction={(purchaseSource) =>
              setPurchaseSource(purchaseSource)
            }
            purchaseSource={purchaseSource}
            subTitle={
              dailyUpgradeSubscription?.total &&
              dailyUpgradeSubscriptionStatus !== 'loading'
                ? `المجموع: ${dailyUpgradeSubscription?.total}`
                : ''
            }
          />

          <ChartDisplay
            loading={dailyUpgradeSubscriptionStatus === 'loading'}
            formatter={(value, time) => {
              return (
                moment.utc(value).local().locale('en').format('DD/MM/YYYY') ||
                value
              );
            }}
            chartType="area"
            seriesData={[
              {
                type: 'area',
                name: 'Users',
                data:
                  dailyUpgradeSubscription?.items?.map((element) => ({
                    y: element.count || 0,

                    x: element.startDate || '',
                  })) || [],
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyUpgradeSubscriptionChart;
